export default __webpack_public_path__ + "static/media/discord.80cf5d44.png";